import { ChangeDetectionStrategy, Component, computed, effect, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SessionRecordingStateService } from '../../../core/session-recording-state.service';
import { ElapsedTimeService } from '../../services/elapsed-time.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { RouterLink } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { ElapsedTimePipe } from '../../pipes/elapsed-time.pipe';

@Component({
  selector: 'app-mind-rec',
  imports: [
    MatIcon,
    MatIconButton,
    MatTooltipModule,
    RouterLink,
    TranslocoDirective,
    MatMenuModule,
    MatDividerModule,
    ElapsedTimePipe,
  ],
  providers: [ElapsedTimeService],
  templateUrl: './mind-rec.component.html',
  styleUrl: './mind-rec.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MindRecComponent {
  private readonly recordingStateService = inject(SessionRecordingStateService);
  private readonly elapsedTimeService = inject(ElapsedTimeService);
  protected readonly recordings = computed(() => {
    const data = this.recordingStateService.activeRecordings();

    return data?.map(m => ({
      projectAndSessionName: `${m.projectName} / ${m.sessionName}`,
      recordingStartedAt: m.startedAt,
      sessionNavigationLink: m.isRecording ? ['projects', m.projectId, m.sessionId] : null,
      staffMonitorQueryParams: m.isRecording
        ? {
            projectId: m.projectId,
            sessionId: m.sessionId,
          }
        : null,
    }));
  });

  constructor() {
    effect(() => (this.recordings() === null ? this.elapsedTimeService.stop() : this.elapsedTimeService.start()));
  }
}
